import { Component, OnInit, signal, WritableSignal } from '@angular/core';
import { PermissionService } from '../../modules/buildings-shared/services/permission.service';
import { Router } from '@angular/router';
import { EnumRoleFullIdentifier } from '../../modules/buildings-shared/model/user-basic-info';

@Component({
  selector: 'app-header',
  imports: [],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit{

    navigationBarInformation: WritableSignal<string> = signal<string>('');

    constructor(private permissionService: PermissionService, private readonly router: Router) { }
    
    ngOnInit(): void {
        this.permissionService.setHeaderInformation();
        // console.log("HeaderComponent.ngOnInit() - Check class name: " + this.constructor.name);
    }

    main() {
        this.router.navigateByUrl("/");
    }

    dossierMain() {
        this.router.navigateByUrl("/dossier/main");
    }

    dossierSearch() {
        this.router.navigateByUrl("/dossier/search");
    }

    dossierDispatch() {
        this.router.navigateByUrl("/dossier/dispatch");
    }

    adminAccounts() {
        this.router.navigateByUrl("/membership/adminAccount");
    }

    adminLegalEntities() {
        this.router.navigateByUrl("/membership/adminLegalEntity");
    }

    accountProfile() {
        this.router.navigateByUrl("/membership/profileAccount");
    }

    legalEntityProfile() {
        this.router.navigateByUrl("/membership/profileLegalEntity");
    }

    logout() {
        this.permissionService.setWaitingSpinner(true);
        this.permissionService.signout().then( (loggedOut: boolean) => {
            console.log('HeaderComponent.logout() - User logged out. Success? ' + loggedOut);
        });
    }

    getHeaderInformation(): string {
        return this.permissionService.getHeaderInformation();
    }

    checkPermissions(permissions: string[]): boolean {
        const fullIdentifiers: EnumRoleFullIdentifier[] = [];
        if(permissions && permissions.length > 0) {
            permissions.forEach( (permission: string) => {
                if(permission in EnumRoleFullIdentifier) {
                    fullIdentifiers.push( EnumRoleFullIdentifier[permission as keyof typeof EnumRoleFullIdentifier] );
                }
            });
        }
        return this.permissionService.checkPermissions(fullIdentifiers);
    }
}
